import React, { useEffect } from 'react';
import { getGrowthbookClientSide } from '@gumtree/shell/src/growthbook/init-growthbook';
import { GrowthBookServerSideFeatures } from '@gumtree/shared/src/model/experiment';

const GrowthBookBucketEmitter: React.FC = () => {
    useEffect(() => {
        // this is to force Growthbook API to send an `experiment_viewed` event which is required for Growthbook to report
        Object.values(GrowthBookServerSideFeatures).forEach((feature) => {
            getGrowthbookClientSide()?.getFeatureValue(feature, '');
        });
    }, []);

    return <></>;
};

export default GrowthBookBucketEmitter;
